import { gql } from '@apollo/client';

export const GET_OSW_VALUE_TAGS = gql`
  query GetOswValueTags {
    tags(ofType: "Values (PSHE, SMSC)", hasWonderLines: true) {
      id
      formattedName
    }
  }
`;

export const LIST_WONDER_LINES = gql`
  query ListWonderLines($filter: ListWonderLinesFilterInput) {
    listWonderLines(filter: $filter) {
      songLine
      learningObjective
      song {
        id
        title
        albumArt
        songWonderDescription
      }
      values
      isBigWonder
      wonderLineSteps {
        type
        headline
        content {
          ... on WonderLineStepContentImage {
            key
            image
          }
          ... on WonderLineStepContentCopy {
            key
            headline
          }
          ... on WonderLineStepContentQAReveal {
            key
            copy
            qas {
              key
              question
              answer
            }
          }
        }
        active
      }
      wonderLineActivities {
        type
        headline
        copy
        files {
          file
          fileName
        }
        active
      }
    }
  }
`;

export const GET_SETTING = gql`
  query GetSetting($group: String!) {
    getSetting(group: $group) {
      value {
        ... on OneSongWondersSetting {
          landingPageBanner
          tooltipTitle
          tooltipCopy
        }
      }
    }
  }
`;
